import React from 'react';
import classNames from 'classnames';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {Button} from 'react-bootstrap';
import styles from './styles.module.scss';

const ButtonExportToExcel = ({
                               exportFunc,
                               loading = false,
                               containerStyles = '',
                               disabled = false
                             }) => {

  return (
    <Button
      type="button"
      className={classNames(styles.exportButton, 'btn btn-sm p-0', containerStyles)}
      onClick={() => exportFunc()}
      disabled={disabled}
    >
      {loading
        ? (
          <div className="spinner-border spinner-border-sm text-light" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )
        : (
          <img
            src={toAbsoluteUrl('/media/svg/Excel_white.svg')}
            alt="export-file"
            height={24}
          />
        )
      }
    </Button>
  );
};

export default ButtonExportToExcel;
